import { useState } from "react"
import Sheet from 'react-modal-sheet';

export default function SortModal(
    { isSortModalOpen, selectedSortType, onSortClick, onSortModalDismiss }
) {
    console.log(`selected sort type ${selectedSortType}`)
    return <Sheet isOpen={isSortModalOpen} onClose={() => {onSortModalDismiss()}} onOpenEnd={() => {}} detent="content-height">
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
        <Sheet.Scroller draggableAt="both">
        <div className="pb-4 px-4">
            <div className="font-bold text-lg py-4 font-titan">Sort by</div>
            <div className="form-control" onClick={(e) => {e.preventDefault();onSortClick("recommended");}}>
                <label className="label cursor-pointer px-0">
                    <span className="label-text text-base">Recommended</span> 
                    <input type="radio" name="radio-updated" className="radio checked:bg-primary" checked={selectedSortType == "recommended"} />
                </label>
            </div>
            <div className="form-control">
                <label className="label cursor-pointer px-0" onClick={(e) => {e.preventDefault();onSortClick("alphabetical")}}>
                    <span className="label-text text-base">Aphabetical</span> 
                    <input type="radio" name="radio-alphabetical" className="radio checked:bg-primary" checked={selectedSortType == "alphabetical"} />
                </label>
            </div>
            <div className="form-control">
                <label className="label cursor-pointer px-0" onClick={(e) => {e.preventDefault();onSortClick("distance")}}>
                    <span className="label-text text-base">Distance from you</span> 
                    <input type="radio" name="radio-distance" className="radio checked:bg-primary" checked={selectedSortType == "distance"} />
                </label>
            </div>
        </div>
      <div className="modal-action pb-4 px-4">

        <button className="btn btn-circle btn-soft" onClick={
                    () => {onSortModalDismiss()}
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
      </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onSortModalDismiss()
        }}/>
    </Sheet>
}